"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveActorEventHandlerActivator = exports.RemoveActorEventHandlerArgs = void 0;
const EventHandlerType_1 = require("../EventHandlerType");
const Registries_1 = require("../../state/Registries");
const IdArray_1 = require("../../utils/IdArray");
const Death_1 = require("../../effects/core/Death");
const Duration_1 = require("../../Duration");
class RemoveActorEventHandlerArgs {
    constructor(actorId) {
        this.actorId = actorId;
        this.__type = EventHandlerType_1.EventHandlerType.RemoveActor;
        this.__typeName = "RemoveActor";
    }
}
exports.RemoveActorEventHandlerArgs = RemoveActorEventHandlerArgs;
let RemoveActorEventHandlerActivator = class RemoveActorEventHandlerActivator {
    activate(sequence, container, handler, event) {
        const self = container.getActor(handler.args.actorId);
        if (!container.isDeceased(self.id)) {
            container.applyEffect(sequence, self.id, self.id, new Death_1.DeathEffectArgs(), Duration_1.Duration.Permanent);
        }
        if (self.ownerId) {
            (0, IdArray_1.removeElement)(container.getActor(self.ownerId).companionIds, self.id);
        }
        container.disableActor(sequence, self.id);
    }
};
RemoveActorEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.RemoveActor)
], RemoveActorEventHandlerActivator);
exports.RemoveActorEventHandlerActivator = RemoveActorEventHandlerActivator;
